import { LinearProgress, styled, Typography } from "@mui/material";
import { LOADING_BAR_WIDTH } from "../../utils/constants/viewConstants";

const LoadingBarContainer = styled('div')(({theme}) => ({
    width: LOADING_BAR_WIDTH,
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.shape.borderRadius * 6,
    boxShadow: theme.shadows[6],
    color: theme.palette.getContrastText(theme.palette.common.white)
}));

const LoadingBar = ({loadingProgress, customLoadingText}) => {
    return (
        <LoadingBarContainer className="p-1">
            <div className="d-flex flex-column gap-0_5">
                <div className="d-flex flex-row jc-center">
                    {
                        customLoadingText ?
                        <Typography>{customLoadingText}</Typography> :
                        loadingProgress !== undefined &&
                        <Typography>Loading: {loadingProgress} %</Typography>
                    }
                </div>
                <LinearProgress 
                    variant={loadingProgress !== undefined ? "determinate" : "indeterminate"} 
                    value={loadingProgress} />
            </div>
        </LoadingBarContainer>
    )
}

export default LoadingBar;